/**
 * @generated SignedSource<<07cc082f540aa4708d5ed2ba99213192>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type BookingWriteAccess = "FULL_WRITE" | "JOIN" | "NONE" | "NON_OWNER_WRITE";
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
export type useTimeSlotListSubscription$variables = {
  agendaId: string;
  isCustomer: boolean;
};
export type useTimeSlotListSubscription$data = {
  readonly timeSlotsChanged: {
    readonly slots: ReadonlyArray<{
      readonly availability?: SlotAvailability;
      readonly bookings?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly canUpdate: boolean | null | undefined;
            readonly id: string;
            readonly ownerClient: {
              readonly __typename: "Customer";
              readonly id: string;
            } | {
              readonly __typename: "Member";
              readonly id: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined;
            readonly rounds: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly __typename: string;
                  readonly courseLayout: {
                    readonly code: string;
                  } | null | undefined;
                  readonly player: {
                    readonly __typename: string;
                    readonly firstName?: string | null | undefined;
                    readonly id: string;
                    readonly lastName?: string | null | undefined;
                  } | null | undefined;
                  readonly transportationType: {
                    readonly code: TransportationCode | null | undefined;
                    readonly customCode: string | null | undefined;
                    readonly name: string | null | undefined;
                  } | null | undefined;
                } | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly status?: BookingStatus;
            readonly writeAccess: BookingWriteAccess | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id?: string;
      readonly isLocked?: boolean;
      readonly lockedUntil?: string | null | undefined;
      readonly usedCapacity?: number;
    } | null | undefined>;
  } | null | undefined;
};
export type useTimeSlotListSubscription = {
  response: useTimeSlotListSubscription$data;
  variables: useTimeSlotListSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agendaId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isCustomer"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "agendaIds.0",
        "variableName": "agendaId"
      }
    ],
    "kind": "ListValue",
    "name": "agendaIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availability",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usedCapacity",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lockedUntil",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canUpdate",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "writeAccess",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = [
  (v2/*: any*/)
],
v11 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "Member",
  "abstractKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": (v10/*: any*/),
  "type": "Customer",
  "abstractKey": null
},
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }
],
v14 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "StandardBooking",
  "abstractKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "DiningBooking",
  "abstractKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "LessonBooking",
  "abstractKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "noShowStatus",
    "value": [
      "PRESENT"
    ]
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customCode",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "player",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "condition": "isCustomer",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ]
    },
    (v9/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTimeSlotListSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SlotsSubscriptionChange",
        "kind": "LinkedField",
        "name": "timeSlotsChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "slots",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BookingConnection",
                    "kind": "LinkedField",
                    "name": "bookings",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BookingEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "ownerClient",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": (v17/*: any*/),
                                "concreteType": "RoundConnection",
                                "kind": "LinkedField",
                                "name": "rounds",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoundEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CourseLayout",
                                            "kind": "LinkedField",
                                            "name": "courseLayout",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TransportationType",
                                            "kind": "LinkedField",
                                            "name": "transportationType",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v19/*: any*/),
                                              (v20/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v21/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "rounds(noShowStatus:[\"PRESENT\"])"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "TimeSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTimeSlotListSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SlotsSubscriptionChange",
        "kind": "LinkedField",
        "name": "timeSlotsChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "slots",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BookingConnection",
                    "kind": "LinkedField",
                    "name": "bookings",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BookingEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v2/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "ownerClient",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v10/*: any*/),
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  }
                                ],
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": (v17/*: any*/),
                                "concreteType": "RoundConnection",
                                "kind": "LinkedField",
                                "name": "rounds",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoundEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v9/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CourseLayout",
                                            "kind": "LinkedField",
                                            "name": "courseLayout",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TransportationType",
                                            "kind": "LinkedField",
                                            "name": "transportationType",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v19/*: any*/),
                                              (v20/*: any*/),
                                              (v2/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v21/*: any*/),
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "rounds(noShowStatus:[\"PRESENT\"])"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "TimeSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "44efb7ce28285df12c076cf83d48e906",
    "id": null,
    "metadata": {},
    "name": "useTimeSlotListSubscription",
    "operationKind": "subscription",
    "text": "subscription useTimeSlotListSubscription(\n  $agendaId: ID!\n  $isCustomer: Boolean!\n) {\n  timeSlotsChanged(agendaIds: [$agendaId]) {\n    slots {\n      __typename\n      ... on TimeSlot {\n        id\n        availability\n        usedCapacity\n        isLocked\n        lockedUntil\n        bookings {\n          edges {\n            node {\n              __typename\n              id\n              canUpdate\n              writeAccess\n              ownerClient {\n                __typename\n                ... on Member {\n                  id\n                }\n                ... on Customer {\n                  id\n                }\n                ... on Node {\n                  __isNode: __typename\n                  id\n                }\n              }\n              ... on StandardBooking {\n                status\n              }\n              ... on DiningBooking {\n                status\n              }\n              ... on LessonBooking {\n                status\n              }\n              rounds(noShowStatus: [PRESENT]) {\n                edges {\n                  node {\n                    __typename\n                    courseLayout {\n                      code\n                      id\n                    }\n                    transportationType {\n                      code\n                      customCode\n                      name\n                      id\n                    }\n                    player {\n                      id\n                      firstName @skip(if: $isCustomer)\n                      lastName @skip(if: $isCustomer)\n                      __typename\n                    }\n                    id\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "faa9e5ec9f918426bc67b5b802ee22da";

export default node;
